import api from 'shared/api'

export const sendConfirmEmail = async ({ accessToken }) => {
  await api.post('/users/resend-confirm-email', null, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
}
